import { ReactNode, memo } from 'react'
import html from 'html-react-parser'

import { unOrphan } from '@/utils/orphans'

import { useMarket } from '@/utils/multi-markets/context'

import { PrimaryTitle, SecondaryTitle } from './Title.styled'

interface Props {
  text: string | ReactNode
  primary?: boolean
  animated?: boolean
  light?: boolean
  className?: string
  id?: string
  highlight?: boolean
  style?: any
  priority?: boolean
  leftAligned?: boolean
}

function Title(props: Props) {
  const {
    text,
    primary,
    light,
    animated,
    className,
    id,
    highlight,
    style,
    priority = false,
    leftAligned = false
  } = props

  const { locale } = useMarket()
  const TitleComponent = primary ? PrimaryTitle : SecondaryTitle

  const normalizeLabel = (label: string | ReactNode) => {
    return typeof label === 'string' ? html(unOrphan(label)) : label
  }

  const enhancedStyle = {
    ...style,
    contentVisibility: priority ? 'visible' : 'auto',
    contain: 'layout paint',
    ...(typeof leftAligned !== 'undefined' && {
      textAlign: leftAligned ? (locale == 'ar' ? 'right' : 'left') : 'center'
    })
  }

  return (
    <TitleComponent
      light={light}
      primary={primary}
      animated={animated}
      className={className}
      highlight={highlight}
      id={id}
      style={enhancedStyle}
    >
      {normalizeLabel(text)}
    </TitleComponent>
  )
}

export default memo(Title)
